import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/storage'

firebase.initializeApp({
    apiKey: "AIzaSyDeEdwAjBuMlk7P5_iXqAAUZG7dDLUXslA",
    authDomain: "gss-lifesciences.firebaseapp.com",
    projectId: "gss-lifesciences",
    storageBucket: "gss-lifesciences.firebasestorage.app",
    messagingSenderId: "991067191604",
    appId: "1:991067191604:web:67e7488c708fa0bc414d61"
});

const fb = firebase;

export default fb;